export default __webpack_public_path__ + "static/media/meteo_station.93adf781.svg";